import Vue from 'vue'
import Router from 'vue-router'
import main from "@/main.js";

import Home from '@/views/Home'
import Work from '@/views/Work'
import Case from '@/views/Case'
import Profile from '@/views/Profile'
import Contact from '@/views/Contact'
import Page404 from '@/views/Page404'


Vue.use(Router)


const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    linkExactActiveClass: 'exact-active',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            // beforeEnter(to, from, next) {
            //     console.log('beforeEnter: HOME')
            //     next()
            // },
        },
        {
            path: '/work',
            name: 'Work',
            component: Work,
            props: {
                workFilter: 'all'
            },
        },
        {
            path: '/work/:workFilter',
            name: 'WorkFilter',
            component: Work,
            props: true
        },
        {
            path: '/work/:workFilter/:case',
            name: 'Case',
            component: Case,
            props: true,
            beforeEnter(to, from, next) {
                if (from.name === 'Work' || from.name === 'WorkFilter') {
                    to.params.routeFromWork = true
                }
                next()
            },
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/:id',
            name: 'Page404',
            component: Page404
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        
        // https://codesandbox.io/s/yvor6vyyw9
        return new Promise(resolve => {
            
            // Emit event from App -> onPageReady
            main.$root.$once("scrollToPosition", () => {
                
                if (savedPosition) {
                    // console.log('ScrollToPosition: ', savedPosition);
                    resolve(savedPosition);
                } else {
                    // Scroll to top
                    resolve({ x: 0, y: 0 });
                }
            });
        });
    
    },
})


export default router;
